<template>
<div id="secure">
    <NewTopMenu />
    <div class="container">
        <div class="columns">
            <div class="column is-3"><button class="button is-medium is-fullwidth" v-on:click="goManageClasses()">Classes/Departments &amp; Users</button></div>
            <div class="column is-3"><button class="button is-medium is-fullwidth" v-on:click="goManageTeachers()">Teachers/Supervisors</button></div>
            <div class="column is-2"><button class="button is-medium is-fullwidth is-primary" v-on:click="goManageBehaviors()">Items</button></div>
            <div class="column is-2"><button class="button is-medium is-fullwidth" v-on:click="goManageNotifications()">Notifications</button></div>
            <div class="column is-2"><button class="button is-medium is-fullwidth" v-on:click="goManageGroups()">Groups</button></div>
        </div>
        
        <div class="card is-hidden1">
            <div class="card-header">
                <p class="card-header-title">                            
                    <nav class="breadcrumb" aria-label="breadcrumbs">
                        <ul>
                            <li>
                                <a v-on:click="goManageBehaviors()">Items</a>
                            </li>
                            <li class="is-active">
                                <a href="#" aria-current="page">Add from template</a>
                            </li>
                        </ul>
                    </nav>
                </p>
            </div>
            <div class="card-content">
                <loading :active.sync="isLoading" 
                    :can-cancel="false" 
                    :is-full-page="true">
                </loading>
                <div class="columns">
                    <div class="column is-12">
                        <center><h2>What do you want to record?</h2></center>
                    </div>
                </div>
                <div class="columns" v-for="category in categories" :key="category._id" v-show="selectFromTemplate">
                    <div class="column is-12">
                        <b-collapse class="card" animation="slide">
                            <template #trigger="props">
                                <div class="card-header" role="button" :aria-controls="category._id">
                                    <!-- <b-checkbox :value="category._id" class="card-header-title" :ref="category._id"> -->
                                    <p class="card-header-title">{{ category.name }}</p>
                                    <!-- </b-checkbox> -->
                                    <a class="card-header-icon">
                                        <b-icon
                                            :icon="props.open ? 'caret-down' : 'caret-up'">
                                        </b-icon>
                                    </a>
                                </div>
                            </template>

                            <div class="card-content">
                                <!-- <b-button type="is-info is-small is-light" v-on:click="checkAllItemsInCategory(1,index)" style="margin-right: 5px; margin-top: -10px;" icon-right="check">Select All</b-button>
                                <b-button type="is-danger is-small is-light" v-on:click="checkAllItemsInCategory(0,index)" style="margin-top: -10px;" icon-right="times">None</b-button> -->
                                <b-taglist>
                                    <b-tag type="is-white" size="is-medium" v-for="item in category.items" :key="item._id">
                                        <b-checkbox :value="item._id" type="is-success" v-model="item.checked">
                                            {{ item.name }}
                                        </b-checkbox>
                                    </b-tag>
                                </b-taglist>
                                <!-- <div class="columns" style="margin-top: 2px;">
                                    <b-field v-for="item in category.items" :key="item._id" class="column is-3">
                                        <b-checkbox :value="item._id" type="is-success" v-model="item.checked">
                                            {{ item.name }}
                                        </b-checkbox>
                                    </b-field>                                    
                                </div> -->
                            </div>
                        </b-collapse>
                    </div>                    
                </div>
                <div class="columns">
                    <div class="column is-6">&nbsp;</div>
                    <div class="column is-3"><b-button type="is-text" v-on:click="displayHideCreateOwnItem()" style="margin: 10px; text-decoration: underline;">{{ labelCreateOwnOrSelect }}</b-button></div>
                    <div class="column is-3" v-show="selectFromTemplate"><b-button type="is-dark" v-on:click="next()" style="margin: 10px;" rounded expanded>DONE</b-button></div>
                </div>
                <div class="content" v-show="createOwn">
                    <add-content></add-content>
                </div>

                <!-- <div v-show="parentsItemList.length > 0">
                    <h3>Parents</h3>
                    <table class="table is-fullwidth is-striped">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Item Name</th>
                                <th>Points</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,index) in parentsItemList" :key="item._id">
                                <td>{{ (index + 1) }}</td>
                                <td>{{ item.name }}</td>
                                <td>{{ item.points }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div> -->
            </div>
        </div>
    </div>
</div>
</template>

<script>
import NewTopMenu from "./../../NewTopMenu";
import DataList from './DataList';
import AddContent from './AddContent';
import axios from "axios";
import { ToastProgrammatic as Toast } from 'buefy'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: "ManageBehaviorsTemplates",
    components: {
        NewTopMenu,
        Loading,
        DataList,
        AddContent
    },
    data() {
        return {
            schoolID: "",
            categories: [],
            selectTemplate: "-1",
            isLoading: false,
            normalItemList: [],
            announcementItemList: [],
            subjectAttendanceItemList: [],
            parentsItemList: [],
            categoryList: [],
            checkedHolder: [],
            selectFromTemplate: true,
            createOwn: false,
            labelCreateOwnOrSelect: "or create your own item"
        };
    },
    beforeMount() {
        this.$emit("authenticated", true);
        console.log("before mount hoho");
        this.getTemplate()
    },
    created() {
        this.schoolID = localStorage.getItem('schoolID');
        console.log("172 schoolID: " + this.schoolID)
    },
    mounted(){
    },
    methods: {
        displayHideCreateOwnItem(){
            if (this.createOwn == false){
                this.selectFromTemplate = false;
                this.createOwn = true;
                this.labelCreateOwnOrSelect = "or select from pre-created items"
            }else{
                this.selectFromTemplate = true;
                this.createOwn = false;
                this.labelCreateOwnOrSelect = "or create your own item"
            }
        },
        next(){
            let self = this
            var selectedItems = []
            for (var i = 0; i < self.categories.length; i++){
                this.categories[i].items.forEach(function(element) {
                    console.log(element.checked)
                    if (element.checked){
                        console.log("174")
                        console.log(element)
                        selectedItems.push(element)
                    }
                });
            }
            console.log("181 selectedItems.length: " + selectedItems.length)
            console.log(selectedItems)

            if (selectedItems.length < 1){
                Toast.open({
                    message: "Please at least select one item to proceed.",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }

            self.isLoading = true;
            this.$swal({
                title: "Confirm?",
                text: "Are you sure you want to import all these selected items?",
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                showCloseButton: true
            }).then((result) => {
                if (result.value){
                    axios.defaults.responseType = 'json'
                    axios.post(process.env.NEW_ENDPOINT + '/behaviors/template/import', {
                        token: localStorage.getItem('jwtTokenV2'),
                        email: localStorage.getItem('email'),
                        selectedItems: selectedItems
                    })
                    .then(response => {
                        self.isLoading = false;
                        if (response.data.success == false) {
                            Toast.open({
                                message: response.data.msg,
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                        } else {
                            Toast.open({
                                color: 'is-dark', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                message: response.data.msg,
                                type: 'is-success',
                                duration: 3000
                            })
                            this.goManageBehaviors()
                        }
                    })
                    .catch(e => {
                        self.isLoading = false;
                        console.log(e)
                    })
                }else{
                    self.isLoading = false;
                }
            })

        },
        checkAllItemsInCategory(select,index) {
            console.log("230 select: " + select + " and index: " + index)

            this.categoryList[index].items = this.categoryList[index].items.map(behavior => ({ ...behavior,
                checked: !this.isAllChecked
            }))
            this.isAllChecked = !this.isAllChecked
            console.log(this.isAllChecked)

            this.categoryList[index].items.forEach(function(element) {
                element.checked = true
                });


            var selectedCategory = this.categoryList[index]
            // console.log(selectedCategory.items)
            
                // selectedCategory.items.forEach(function(element) {
                //     console.log(element)
                //     console.log(element.checked)
                //     if (select == 1){
                //         element.checked
                //     }
                // });

            // for (var i = 0; i < selectedCategory.length; i++){
            // }

            // console.log(this.categoryList[index]._id)
            // console.log(this.$refs[this.categoryList[index]._id])
            // console.log(this.$refs[this.categoryList[index]._id[0].input])
            // // console.log(this.$refs[this.categoryList[index]._id][0])
            // // console.log(this.$refs[this.categoryList[index]._id][0]._uid)
            // console.log(this.$refs[this.categoryList[index]._id][0].$refs)
            // console.log(this.$refs[this.categoryList[index]._id][0].$refs.input)
            // console.log(this.$refs[this.categoryList[index]._id][0].$refs.input.checked)

            // // alert(this.$refs[this.categoryList[index]._id][0].$refs.input.checked)
            // if (this.$refs[this.categoryList[index]._id][0].$refs.input.checked == false){
            //     console.log("checked?")
            // }else{
            //     console.log("tak?")
            // }
        },
        goExternalPage(){
            window.open("https://www.studentqr.com/list-of-behavior", '_blank');
        },
        getTemplate(){
            let self = this;
            self.isLoading = true;
            self.categories = []
            self.categoryList = []

            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/behaviors/template/view', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email')
            }).then(response => {
                if (response.data.success == true){
                    self.categories = response.data.categories
                    for (var i = 0; i < self.categories.length; i++){
                        for (var j = 0; j < self.categories[i].items.length; j++){
                            //need to assign the category to the item's category property here so that we can link the item and category using the code yg imin dah buat, kalau tak byk nak kena tukar lagi
                            var categoryData = {
                                _id: self.categories[i]._id,
                                name: self.categories[i].name,
                                colour: self.categories[i].colour,
                                points: self.categories[i].points,
                            }
                            self.categories[i].items[j].category = categoryData
                        }
                    }
                    console.log("296 self.categories.length: " + self.categories.length)
                    console.log(self.categories)
                    // self.categoryList = response.data.categories
                    // self.checkedHolder = []
                    // for (var i = 0; i < self.categoryList.length; i++){
                    //     var itemsInCategory = []
                    //     for (var j = 0; j < self.templateItems.length; j++){
                    //         if (self.templateItems[j].category._id == self.categoryList[i]._id){
                    //             itemsInCategory.push(self.templateItems[j])
                    //         }
                    //     }
                    //     self.categoryList[i].items = itemsInCategory
                    // }
                }else{
                    Toast.open({
                        message: response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                }
                self.isLoading = false

                // ok nnt imin loop guna self.categoryList utk buat view mcm dlm design
            })
            .catch(e => {
                self.isLoading = false
                console.log(e)
            })
        },
        goManageClasses(){
            this.$router.push({
                name: "ManageClassesHome"
            });
        },
        goManageStudents(){
            this.$router.push({
                name: "ManageStudentsHome"
            });
        },
        goManageTeachers(){
            this.$router.push({
                name: "ManageTeachersHome"
            });
        },
        goManageBehaviors(){
            this.$router.push({
                name: "ManageBehaviorsHome"
            });
        },
        goManageNotifications(){
            this.$router.push({
                name: "ManageNotificationsHome"
            });
        },   
        goManageGroups(){
            this.$router.push({
                name: "ManageGroupsHome"
            });
        },
        goManageBadges(){
            this.$router.push({
                name: "ManageBadgesHome"
            });
        },
        goManageBehaviorTags(){
            this.$router.push({
                name: "ManageBehaviorsTagsHome"
            });
        },
    },
};
</script>

<style scoped>
.container{
    padding: 10px;
}
h2{
    font-size: 20pt;
    font-weight: bold;
}
.box{
    border: 1px solid #ccc;
    width: 40% !important;
    margin: 4px;
    padding: 0px !important;
}
.active{
    border: 1px solid rgb(6, 50, 247);
}
</style>



// WEBPACK FOOTER //
// src/components/Manage/Behaviors/Templates.vue